import axios from "axios";
import store from "@/store";

// proship-messenger (Facebook Pages, tracking messages). Its own instance on purpose:
// helpers/http.js sends every 401 to Login and toasts 400/422 bodies, while a Messenger
// outage or refusal must only show an inline state on the screen that asked.
const baseURL = process.env.VUE_APP_MESSENGER_API || "https://proship-messenger.fly.dev";

export const messengerHttp = axios.create({ baseURL, timeout: 30000 });

messengerHttp.interceptors.request.use((config) => {
  const authData = store.state.user && store.state.user.authData;
  if (authData && authData.token) config.headers.Authorization = "Bearer " + authData.token;
  return config;
});

// Any failure as {status, code, detail}: status 0 + code "unreachable" when no answer came back
// (network, CORS, timeout); otherwise the HTTP status and the API's `error` code.
export const messengerError = (err) => {
  const response = err && err.response;
  if (!response) return { status: 0, code: "unreachable", detail: null };
  const data = response.data && typeof response.data === "object" ? response.data : {};
  return {
    status: response.status,
    code: data.error || "http_" + response.status,
    detail: data.detail || null,
  };
};
